//claimPostingData.ts
import { ClaimPostingRecord } from '@dataTypes/claimFeature.types'

export const claimPostingData: ClaimPostingRecord[] = [
  {
    id: '1',
    code: 'C001',
    dateSubmitted: '2024-03-01',
    clinicFee: 200,
    contractAmt: 180,
    deductible: 20,
    writeOff: 10,
    coPay: 15,
    approvedAmt: 170,
  },
  {
    id: '2',
    code: 'C002',
    dateSubmitted: '2024-03-05',
    clinicFee: 250,
    contractAmt: 200,
    deductible: 30,
    writeOff: 15,
    coPay: 20,
    approvedAmt: 190,
  },
  {
    id: '3',
    code: 'C003',
    dateSubmitted: '2024-03-10',
    clinicFee: 300,
    contractAmt: 260,
    deductible: 25,
    writeOff: 10,
    coPay: 20,
    approvedAmt: 230,
  },
  {
    id: '4',
    code: 'C004',
    dateSubmitted: '2024-03-12',
    clinicFee: 150,
    contractAmt: 140,
    deductible: 15,
    writeOff: 5,
    coPay: 10,
    approvedAmt: 130,
  },
  {
    id: '5',
    code: 'C005',
    dateSubmitted: '2024-03-15',
    clinicFee: 280,
    contractAmt: 250,
    deductible: 40,
    writeOff: 10,
    coPay: 25,
    approvedAmt: 220,
  },
]
